import Typography from '@components/std-components/Typography'
import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import ViewContext from '@modules/order/contexts/view-context'
import formatNumberByLocale from '@utils/format-number-by-locale'
import get from 'lodash/result'
import React, { FC, useContext } from 'react'
import FieldSkeleton from '../../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../../components/HierarchyCell'
const GenericValueComponent: FC<CellItem> = ({ rowData, column }) => {
  const {
    uiStore: { getHierarchy }
  } = useContext(ViewContext)
  if (!rowData) {
    return (
      <HierarchyCell>
        <FieldSkeleton />
      </HierarchyCell>
    )
  }
  const hierarchy = rowData?.name && getHierarchy(rowData?.name)
  const val = Number(get(hierarchy?.[hierarchy?.length - 1], column?.field) ?? 0)
  return (
    <HierarchyCell>
      <Typography variant='subHeading1'>{formatNumberByLocale(val)}</Typography>
    </HierarchyCell>
  )
}

export default GenericValueComponent
